"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProtocol = void 0;
var getProtocol = function (useHttps) { return useHttps !== false ? "https://" : "http://"; };
exports.getProtocol = getProtocol;
